export default __webpack_public_path__ + "static/media/dex.cd28e7cd.svg";